export const CENTER_FRESH_MS = 90000;
export const CENTER_REFRESH_MS = 60000;
export const CENTER_BLOCKED_REFRESH_MS = 5000;

export function validCenterSnapshot(data) {
    const limits = value => value && Number.isInteger(value.max_orders) && Number.isInteger(value.max_operators);
    return data?.version === 1 && Number.isFinite(Date.parse(data.observed_at))
        && limits(data.default_limits) && Array.isArray(data.phase_causals)
        && data.phase_causals.every(item => typeof item?.fase === "string" && typeof item.causale === "string")
        && Array.isArray(data.centers) && data.centers.every(center =>
            center && (center.centro === null || typeof center.centro === "string") && limits(center) && Array.isArray(center.active_timers)
            && center.active_timers.every(timer => timer && (timer.ordine === null || typeof timer.ordine === "string")
                && Number.isInteger(timer.matricola) && Number.isInteger(timer.id) && Number.isInteger(timer.operazione)
                && (timer.causale === null || typeof timer.causale === "string")));
}

/** Mirror the capacity checks after timbra_inizio's automatic timer closures. */
export function centerAvailability(state, { centro, ordine, matricola, fase, setup = false, closingSetupId = null } = {}) {
    const unknown = { status: "unknown", blocked: true, label: "Da verificare", detail: "Disponibilità del centro non verificata. Aggiornamento automatico in corso." };
    if (!state?.snapshot || state.error || state.dirty || !state.receivedAt
        || state.now - state.receivedAt > CENTER_FRESH_MS || !centro) return unknown;
    const snapshot = state.snapshot;
    const center = snapshot.centers.find(item => item.centro === String(centro));
    const limits = center || snapshot.default_limits;
    const selected = Number(matricola) > 0;
    const effective = snapshot.phase_causals.find(item => item.fase.toLowerCase() === String(fase || "").toLowerCase())?.causale
        || (setup ? "attrezzaggio" : "lavorazione");
    const closing = closingSetupId === null ? null : snapshot.centers.flatMap(item => item.active_timers)
        .find(timer => String(timer.id) === String(closingSetupId));
    const closingCausal = snapshot.phase_causals.find(item => item.fase.toLowerCase() === String(fase || "").toLowerCase())?.causale || "attrezzaggio";
    const timers = (center?.active_timers || []).filter(timer => {
        if (closing && timer.matricola === closing.matricola && timer.ordine === closing.ordine
            && timer.operazione === closing.operazione && timer.causale === closingCausal) return false;
        if (!selected || Number(timer.matricola) !== Number(matricola)) return true;
        return timer.causale === "lavorazione" || (timer.causale === "attrezzaggio" && effective === "attrezzaggio");
    });
    const otherOrders = timers.filter(timer => !ordine || timer.ordine !== ordine);
    const otherOperators = timers.filter(timer => !selected || Number(timer.matricola) !== Number(matricola));
    const orderBlocked = limits.max_orders > 0 && new Set(otherOrders.map(timer => timer.ordine)).size >= limits.max_orders;
    const operatorBlocked = limits.max_operators > 0 && new Set(otherOperators.map(timer => timer.matricola)).size >= limits.max_operators;
    const blocked = orderBlocked || operatorBlocked;
    const relevant = blocked ? (orderBlocked ? otherOrders : otherOperators) : timers;
    const detail = [...new Set(relevant.map(timer => `${timer.ordine || 'Senza ODP'} · ${timer.operatore || `Operatore ${timer.matricola}`}`))].join("; ");
    const occupied = (center?.active_timers || []).length > 0;
    return { status: blocked ? "busy" : "free", blocked, label: blocked ? "Impegnato" : occupied ? "In uso · avvio consentito" : "Libero", detail, occupied };
}

export function startButtonLabel(matricola, availability, active = false) {
    if (active) return "AVVIO…";
    if (!(Number(matricola) > 0)) return "Seleziona operatore";
    if (availability.status === "unknown") return "Verifica disponibilità";
    if (availability.blocked) return "Centro già impegnato — avvio impossibile";
    return "INIZIA";
}
